import { render, staticRenderFns } from "./AllocationsByMunicipality.vue?vue&type=template&id=7ca69330&scoped=true"
import script from "./AllocationsByMunicipality.vue?vue&type=script&lang=js"
export * from "./AllocationsByMunicipality.vue?vue&type=script&lang=js"
import style0 from "./AllocationsByMunicipality.vue?vue&type=style&index=0&id=7ca69330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca69330",
  null
  
)

export default component.exports